import { Close } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Button from 'src/components/Buttons/Button';
import React from 'react';
import {
  TermsContentContainer,
  TermsContainer,
} from 'src/components/Modal/Modal.styles';
import Box from '@mui/material/Box';
import { returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';
import { Modal } from '@mui/material';

interface IModal {
  title: string;
  handleClose: () => void;
  children: any;
  isOpen: boolean;
  width?: string;
  height?: string;
  isDownloadPDFLink?: any;
  handleDownloadPDF?: any;
  marginTop?: any;
}

const HBSModal: React.FC<IModal> = ({ isOpen, width, height, title, handleClose, children, isDownloadPDFLink, handleDownloadPDF, marginTop }) => {
  const { breakpoints } = useTheme();
  const matches = useMediaQuery(breakpoints.down('md'));
  const matchesSM = useMediaQuery(breakpoints.down('sm'));

  return <Modal open={isOpen}>
    <Box sx={{
      display: "flex",
      justifyContent: 'center',
      alignItems: 'center',
      height: "100%"
    }}>
      <TermsContainer>
        <TermsContentContainer>
          <Box sx={{ height: "100px" }}>
            <Grid
              item
              container
              alignItems="center"
              justifyContent="space-between"
              flexWrap='nowrap'
            >
              <Typography
                component="h2"
                variant="h2"
                fontSize={matches ? 16 : 24}
                lineHeight="initial"
              >
                {title}
              </Typography>
              <Box display="flex" flexDirection={matchesSM ? 'column' : 'row'}>
                {returnIsNotEmptyOrTrue(isDownloadPDFLink,
                  (<IconButton
                    onClick={handleDownloadPDF}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Typography color="primaryColor" fontSize={matches ? 14 : 16}>
                      Download/Print
                    </Typography>
                  </IconButton>),
                  null)}
                <IconButton
                  onClick={handleClose}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: "0px !important"
                  }}
                >
                  <Close
                    sx={{
                      cursor: 'pointer',
                      color: 'primaryColor',
                      padding: 0,
                    }}
                  />
                  <Typography color="primaryColor" fontSize={matches ? 14 : 16}>
                    Close
                  </Typography>
                </IconButton>
              </Box>
            </Grid>
          </Box>
          <Box sx={{ flexGrow: 1, overflowY: "auto", margin:"24px 0px" }}>
            {children}
          </Box>
          <Box sx={{ height: "50px", width:"100%" }}>
            <Box sx={{display:"flex", justifyContent:"flex-end"}}>
              <Button
                text="Close"
                onClick={handleClose}
                variant="outlined"
                px={45}
              />
            </Box>
          </Box>
        </TermsContentContainer>
      </TermsContainer>
    </Box>
  </Modal>
}

export default HBSModal;
